import * as React from 'react'
import { cn } from '@/lib/utils'

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical'
  label?: string
}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ orientation = 'horizontal', label, className, ...props }, ref) => {
    if (label && orientation === 'horizontal') {
      return (
        <div ref={ref} className={cn('flex items-center gap-3', className)} {...props}>
          <div className="flex-1 h-px bg-[var(--color-border)]" />
          <span className="text-xs text-muted-foreground whitespace-nowrap">{label}</span>
          <div className="flex-1 h-px bg-[var(--color-border)]" />
        </div>
      )
    }

    if (orientation === 'vertical') {
      return (
        <div
          ref={ref}
          className={cn('w-px self-stretch bg-[var(--color-border)]', className)}
          {...props}
        />
      )
    }

    return (
      <div
        ref={ref}
        className={cn('w-full h-px bg-[var(--color-border)]', className)}
        {...props}
      />
    )
  }
)
Divider.displayName = 'Divider'

export { Divider }
